var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 1H3a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z",
    fill: "#22ade7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.2h1.7l-.8-2Zm14.2-2v1.3h1.9v1h-1.9v1.3h2.1l1.5-1.8-1.3-1.7Zm6.1 4.8-1.6-1.9L23 15h-4.2V9.1h4.4l1.5 1.9 1.6-1.9h1.6L25.5 12l2.3 3Zm-8.4 0h-1.6v-4.4L14.6 15h-1.3l-1.9-4.4V15H8.7l-.5-1.5H5.5L5 15H3.5l2.4-5.9h1.8l2.3 5.6V9.1h2.2l1.7 3.9 1.7-3.9h2.3Zm8.9-3 1.8-2.3L30 8h-4.2l-.3.4-.8.9-.7-.9-.3-.4H15l-.3.6-.8 1.8-.8-1.8-.2-.6H9v1.5l-.3-.9-.3-.6H5.3l-.3.6-2.4 5.9L2 16h3.7l.2-.7.3-.8h1.3l.3.8.2.7h4.4v-.5l.2.5h2.6l.1-.1v.1h8.2l.3-.3.9-1 .9 1 .3.4H30l-1.3-1.7Z",
    fill: "#fff"
  })));
};
export default SvgAmex;